import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  InputNumber,
  Form,
  SelectPicker,
  DatePicker,
  RadioGroup,
  Radio,
} from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'

export default function ProjectChangedStatusProcessForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  getValues,
  clearErrors,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [fromBudgetYearOptions, setFromBudgetYearOptions] = useState(
    schema.budgetYearStartOption.options
  )
  const [toBudgetYearOptions, setToBudgetYearOptions] = useState(schema.budgetYearEndOption.options)

  useEffect(() => {
    if (!clearValue) {
      console.log(schema)
      setStartDate(null)
      setEndDate(null)

      setValue(schema.periodNoDisplay.name, '0')

      const indexOptionFromBudgetYear = schema.budgetYearEndOption.options.length - 1
      const indexOptionToBudgetYear = schema.budgetYearEndOption.options.length - 1

      setValue(
        schema.budgetYearStartOption.name,
        schema.budgetYearStartOption.options[indexOptionFromBudgetYear].value
      )
      setValue(
        schema.budgetYearEndOption.name,
        schema.budgetYearEndOption.options[indexOptionToBudgetYear].value
      )
    }
  }, [clearValue])

  const handleChangeBudgetYear = (name, value) => {
    console.log(name, value)
    if (value) {
      let bgy = getValues(name)
      if (!bgy) {
        setValue(name, value)
        clearErrors(name)
      } else if (name == schema.budgetYearStartOption.name && bgy > value) {
        setValue(name, value)
      } else if (name == schema.budgetYearEndOption.name && bgy < value) {
        setValue(name, value)
      }

      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(
          schema.budgetYearStartOption.options.filter((e) => e.value <= value)
        )
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options.filter((e) => e.value >= value))
      }
    } else {
      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(schema.budgetYearStartOption.options)
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options)
      }
    }
  }

  return (
    <>
      <Form>
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.preApprovedProjectStartDate.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.preApprovedProjectStartDate.name]} />
            <Controller
              key={schema.preApprovedProjectStartDate.name}
              name={schema.preApprovedProjectStartDate.name}
              control={control}
              defaultValue={
                schema.preApprovedProjectStartDate.value
                  ? moment(schema.preApprovedProjectStartDate.value, DATE_PICKER_FORMAT).toDate()
                  : null
              }
              // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    value={startDate}
                    onChange={(value) => {
                      const date = moment(value).format(DATE_PICKER_FORMAT)
                      props.onChange(value)
                      setStartDate(value)
                    }}
                    disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
                  />
                )
              }}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.preApprovedProjectEndDate.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.preApprovedProjectEndDate.name]} />
            <Controller
              key={schema.preApprovedProjectEndDate.name}
              name={schema.preApprovedProjectEndDate.name}
              control={control}
              defaultValue={
                schema.preApprovedProjectEndDate.value
                  ? moment(schema.preApprovedProjectEndDate.value, DATE_PICKER_FORMAT).toDate()
                  : null
              }
              // rules={isValidators(schema.preApprovedProjectEndDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    value={endDate}
                    onChange={(value) => {
                      const date = moment(value).format(DATE_PICKER_FORMAT)
                      props.onChange(value)
                      setEndDate(value)
                    }}
                    disabledDate={(date) =>
                      startDate && moment(startDate).isAfter(date, new Date())
                    }
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          {schema?.budgetYearStartOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearStartOption.validators,
                  schema.budgetYearStartOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearStartOption.name]} />
                <Controller
                  name={schema.budgetYearStartOption.name}
                  control={control}
                  defaultValue={
                    fromBudgetYearOptions
                      ? Math.max(...fromBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearStartOption.value
                  }
                  // rules={isValidators(schema.fromBudgetYear.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={fromBudgetYearOptions}
                        // disabled={disabledValue.fromBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearStartOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {schema?.budgetYearEndOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearEndOption.validators,
                  schema.budgetYearEndOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearEndOption.name]} />
                <Controller
                  name={schema.budgetYearEndOption.name}
                  control={control}
                  defaultValue={
                    toBudgetYearOptions
                      ? Math.max(...toBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearEndOption.value
                  }
                  // rules={isValidators(schema.budgetYearEndOption.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={toBudgetYearOptions}
                        // disabled={disabledValue.toBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearEndOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearStartOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.startBudget.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors.startBudget} />
            <Input
              placeholder={schema.startBudget.hint}
              defaultValue={schema.startBudget.value}
              name={schema.startBudget.name}
              type="number"
              // inputRef={register(isValidators(schema.startBudget.validators))}
              inputRef={register()}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.endBudget.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors.endBudget} />
            <Input
              placeholder={schema.endBudget.hint}
              defaultValue={schema.endBudget.value}
              name={schema.endBudget.name}
              type="number"
              // inputRef={register(isValidators(schema.startBudget.validators))}
              inputRef={register()}
            />
          </Col>
        </Row>
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.periodNoDisplay.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors.periodNoDisplay} />
            <Controller
              name={schema.periodNoDisplay.name}
              control={control}
              defaultValue={schema.periodNoDisplay.value || '0'}
              // rule={register(isValidators(schema.periodNoDisplay.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    name={schema.periodNoDisplay.name}
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.periodNoDisplay?.options &&
                      schema.periodNoDisplay.options.map((item) => (
                        <Radio key={item.value} value={item.value}>
                          {item.label}
                        </Radio>
                      ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>

          {schema.projectDepartment && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectDepartment.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectDepartment.name]} />
                <Controller
                  name={schema.projectDepartment.name}
                  control={control}
                  defaultValue={schema.projectDepartment.value}
                  // rules={isValidators(schema.projectDepartment.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={schema.projectDepartment.options}
                        // disabled={disabledValue.constYear}
                        value={props.value}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          // onChangeMainProject(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
      </Form>
    </>
  )
}
